import { ref } from "vue";

/** Shared state: mobile drawer lives in Sidebar; trigger lives in PrivateHeader. */
const isMenuOpen = ref(false);

/*
 * The element that opened the drawer, so focus can return to it on close. Without this, dismissing
 * the drawer left `document.activeElement` on <body> and a keyboard or screen-reader user lost
 * their place entirely.
 */
let lastFocused: HTMLElement | null = null;

export function useMobileSidebarMenu() {
  function openMenu() {
    if (typeof document !== "undefined") {
      lastFocused = document.activeElement as HTMLElement | null;
    }
    isMenuOpen.value = true;
  }

  /**
   * @param restoreFocus send focus back to whatever opened the drawer. True for a real dismissal
   *   (Escape, the close button, tapping the scrim); false when the drawer is closing because the
   *   user navigated, where focus belongs to the incoming page rather than the hamburger.
   */
  function closeMenu(restoreFocus = true) {
    if (!isMenuOpen.value) return;
    isMenuOpen.value = false;

    if (restoreFocus) {
      lastFocused?.focus?.();
    }
    lastFocused = null;
  }

  return {
    isMenuOpen,
    openMenu,
    closeMenu,
  };
}
